import React from 'react'
import { CSSTransition } from 'react-transition-group'

import CompareProperty from '@components/compare-property/v2'

import { useCompareProperty } from '@adUtilities/components/compare-property/utils'
import { PropertyType } from '@adUtilities/types'

interface PropertyCompareTransitionWrapperProps {
  children: React.ReactNode
  propertyType: PropertyType
  comparePropertyProps: ReturnType<typeof useCompareProperty>
  fullScreenMode: boolean
  onFullScreenToggle: (status: boolean) => void
  triggerComparisonStop: () => Promise<void>
}

const TRANSITION_TIMEOUT = 500
const TRANSITION_TIMEOUT2 = 300
const TRANSITION_CLASSNAME = 'transition-property-compare-v2'
const TRANSITION_CLASSNAME2 = 'transition-property-uncompare-v2'

function PropertyCompareTransitionWrapper({
  children,
  propertyType,
  comparePropertyProps,
  fullScreenMode,
  onFullScreenToggle,
  triggerComparisonStop,
}: PropertyCompareTransitionWrapperProps) {
  const { compareModeIsActive } = comparePropertyProps
  return (
    <>
      <CSSTransition
        timeout={compareModeIsActive ? TRANSITION_TIMEOUT : 0}
        in={compareModeIsActive}
        classNames={TRANSITION_CLASSNAME}
        mountOnEnter
        unmountOnExit
      >
        <div className="h-full w-full flex-1">
          <CompareProperty
            propertyType={propertyType}
            comparePropertyProps={comparePropertyProps}
            fullScreenMode={fullScreenMode}
            onFullScreenToggle={onFullScreenToggle}
            triggerComparisonStop={triggerComparisonStop}
          />
        </div>
      </CSSTransition>
      <CSSTransition
        timeout={!compareModeIsActive ? TRANSITION_TIMEOUT2 : 0}
        in={!compareModeIsActive}
        classNames={TRANSITION_CLASSNAME2}
        mountOnEnter
        unmountOnExit
      >
        {children}
      </CSSTransition>
    </>
  )
}

export default PropertyCompareTransitionWrapper
